
export default {
  name: 'NoContent',
  computed: {
    emptyText() {
      return this.$t('page.NO_CONTENT_1')
    }
  }
}
